var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-menu",
    {
      ref: "menu",
      attrs: {
        "close-on-content-click": false,
        transition: "scale-transition",
        "offset-x": "",
        "offset-y": "",
        "min-width": "290px",
      },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function (ref) {
            var on = ref.on
            return [
              _c("v-select", {
                attrs: {
                  label: "Chosen Days",
                  items: _vm.selectItems,
                  "error-messages": _vm.errorMessages,
                  chips: "",
                  multiple: "",
                  "deletable-chips": "",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "append",
                      fn: function () {
                        return [
                          _c(
                            "v-btn",
                            _vm._g({ attrs: { icon: "" } }, on),
                            [_c("v-icon", [_vm._v("event")])],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "no-data",
                      fn: function () {
                        return undefined
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  true
                ),
                model: {
                  value: _vm.selectItems,
                  callback: function ($$v) {
                    _vm.selectItems = $$v
                  },
                  expression: "selectItems",
                },
              }),
            ]
          },
        },
      ]),
      model: {
        value: _vm.dayChooser,
        callback: function ($$v) {
          _vm.dayChooser = $$v
        },
        expression: "dayChooser",
      },
    },
    [
      _c(
        "v-date-picker",
        {
          attrs: { "no-title": "", scrollable: "", multiple: "" },
          on: { change: _vm.emitChange },
          model: {
            value: _vm.pickedDates,
            callback: function ($$v) {
              _vm.pickedDates = $$v
            },
            expression: "pickedDates",
          },
        },
        [
          _c("v-spacer"),
          _c(
            "v-btn",
            {
              attrs: { text: "", color: "primary" },
              on: {
                click: function ($event) {
                  _vm.dayChooser = false
                },
              },
            },
            [_vm._v(" OK ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }